export const WIZARD_FORM_KEY = 'wizardForm';
export const WIZARD_UPLOAD_KEY = 'wizardUpload';

// Rich-text (Quill) fields hold HTML; an empty editor still yields "<p><br></p>".
// Treat such a field as filled only when it contains actual text/media.
export function hasRichText(html) {
  if (!html) return false;
  const text = String(html)
    .replace(/<(br|img|video|iframe)[^>]*>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();
  return text.length > 0;
}

export const wizardFormInject = {
  inject: {
    getWizardForm: { from: WIZARD_FORM_KEY },
    uploadFile: { from: WIZARD_UPLOAD_KEY, default: () => () => Promise.resolve(null) },
  },
  computed: {
    form() {
      return this.getWizardForm();
    },
  },
};
